import React from "react";
import AuFlag from "@ecologi/assets/icons/Flags/au.svg";
import BrFlag from "@ecologi/assets/icons/Flags/br.svg";
import UkFlag from "@ecologi/assets/icons/Flags/uk.svg";
import UsFlag from "@ecologi/assets/icons/Flags/us.svg";
import { LocalProject } from "@ecologi/shared";

type CountryIconsType = {
  flag: JSX.Element;
  pictogram: string;
};

export const BIRTHDAY_BLOG_ARTICLES = {
  "2020": {
    title: "Our first year of climate action",
    blogUrl: "/articles/updates/our-first-year-in-numbers",
  },
  "2021": {
    title: "Our second year of climate action",
    blogUrl: "/articles/blog/celebrating-two-years-of-impact",
  },
};

export const COUNTRY_ICONS: Record<LocalProject["country"], CountryIconsType> =
  {
    AU: {
      flag: <AuFlag />,
      pictogram: "/images/app/forest/countries/au.svg",
    },
    BR: {
      flag: <BrFlag />,
      pictogram: "/images/app/forest/countries/br.svg",
    },
    UK: {
      flag: <UkFlag />,
      pictogram: "/images/app/forest/countries/uk.svg",
    },
    US: {
      flag: <UsFlag />,
      pictogram: "/images/app/forest/countries/us.svg",
    },
  };

export const DIVIDEND_BLOG_URL =
  "https://ecologi.com/articles/updates/tree-dividend-march-2020";

export const SAPLING_ICON_URL = "/images/app/sapling.svg";
